import { actionCopyEs } from "./actionCopy";
import { listCopyEs } from "./listCopy";

export const profileCopyEs = {
    title: "Perfil",
    description: "Gestione su perfil y sus ajustes",
    contactDetails: "Datos de contacto",
    name: listCopyEs.name,
    titleLabel: "Título",
    selectPlaceholder: "Seleccionar",
    requiredField: "Obligatorio",
    firstNameRequired: "El nombre es obligatorio",
    lastNameRequired: "Los apellidos son obligatorios",
    firstName: "Nombre",
    lastName: "Apellidos",
    noName: "Sin nombre",
    dateOfBirth: listCopyEs.dateOfBirth,
    dateOfBirthFormatDescription: "Use el formato DD MM AAAA.",
    dobPlaceholderDay: "DD",
    dobPlaceholderMonth: "MM",
    dobPlaceholderYear: "AAAA",
    dobDayRequired: "El día es obligatorio",
    dobMonthRequired: "El mes es obligatorio",
    dobYearRequired: "El año es obligatorio",
    dobMaxDaysInMonth: "Un mes tiene como máximo 31 días",
    dobMonthsInYear: "Un año solo tiene 12 meses",
    dobYearTooEarly: "Este año es demasiado antiguo",
    dobYearInFuture: "Está en el futuro.",
    noDateOfBirth: "Sin fecha de nacimiento",
    email: listCopyEs.email,
    noEmail: "Sin dirección de correo electrónico",
    updateEmail: "Modificar la dirección de correo electrónico",
    validEmailAddress: "Indique una dirección de correo electrónico válida",
    accountSignInEmailRequired:
        "Indique la dirección de correo electrónico de acceso de la cuenta que está modificando",
    newEmailDifferentFromSignIn:
        "La nueva dirección de correo electrónico debe ser distinta de la dirección de correo electrónico de acceso que está sustituyendo",
    newEmailDifferentFromCurrent: "La nueva dirección de correo electrónico debe ser distinta de su dirección actual",
    differentEmailAddress: "Indique una dirección de correo electrónico distinta",
    noSignInEmailToChange: "No hay ninguna dirección de correo electrónico de acceso que modificar",
    emailUpdatedSuccessfully: "Dirección de correo electrónico actualizada correctamente",
    emailUpdateFailed: "No se ha podido actualizar la dirección de correo electrónico. Vuelva a intentarlo.",
    emailSavedToProfile: "Dirección de correo electrónico guardada en su perfil",
    emailSaveToProfileFailed:
        "No se ha podido guardar la dirección de correo electrónico en su perfil. Vuelva a intentarlo.",
    loading: actionCopyEs.loading,
    profileEmailIntro: (email) => `La dirección de correo electrónico del perfil es ${email}.`,
    profileEmailIntroSuffix: "Indique la nueva dirección a continuación.",
    signInEmailDiffersHelp:
        "Si la dirección de correo electrónico de acceso difiere de la del perfil (por ejemplo, tras un problema de sincronización), use el campo opcional.",
    noProfileEmailReplaceDescription:
        "No hay ninguna dirección de correo electrónico en este perfil. Indique la dirección de correo electrónico de acceso de la cuenta que va a sustituir y, a continuación, la nueva dirección.",
    signInEmailOnlyIfDifferent: "Dirección de correo electrónico de acceso (solo si es distinta de la del perfil)",
    signInEmail: "Dirección de correo electrónico de acceso",
    leaveBlankIfSameAsProfile: "Déjelo en blanco si coincide con la del perfil",
    newEmail: "Nueva dirección de correo electrónico",
    emailAddressToChangeTo: "Dirección de correo electrónico que desea usar",
    accountSignInEmailIntro: (email) =>
        `La dirección de correo electrónico de acceso de su cuenta es ${email}, pero aún no aparece en su perfil. Puede guardarla en su perfil ahora.`,
    saveEmailToProfile: "Guardar la dirección de correo electrónico en el perfil",
    saveEmailFirstDescription:
        "Una vez guardada, podrá cambiar de dirección desde esta ventana. Para pasar a otra dirección con un enlace de confirmación previo, use",
    noProfileEmailAddDescription:
        "Su perfil aún no tiene una dirección de correo electrónico. Añada una a continuación - por ejemplo, si se registró con su número de teléfono.",
    profileEmailLink: "Perfil - Correo electrónico",
    noEmailOnAccountPhoneSignup:
        "No hay ninguna dirección de correo electrónico en esta cuenta por el momento (por ejemplo, si se registró con el teléfono)",
    currentEmail: "Dirección de correo electrónico actual",
    emailConfirmationSecurityDescription:
        "Le enviaremos un enlace de confirmación por correo electrónico. Por motivos de seguridad, no cambiará nada hasta que abra este enlace.",
    emailConfirmationSent:
        "Confirmación enviada - compruebe la nueva bandeja de entrada para encontrar nuestro enlace. Su dirección de correo electrónico de acceso no cambiará hasta que lo haya confirmado.",
    emailChangeStartFailed:
        "No se ha podido iniciar el cambio de dirección de correo electrónico. Vuelva a intentarlo.",
    sending: actionCopyEs.sending,
    sendConfirmationEmail: "Enviar el correo de confirmación",
    phone: "Teléfono",
    noPhoneNumber: "Sin número de teléfono",
    notifications: "Notificaciones",
    notificationPreferences: "Preferencias de notificación",
    notificationPreferencesMissing: "Faltan las preferencias de notificación",
    notificationPreferencesNotSpecified: "Preferencias de notificación no especificadas",
    notificationPreferencesDescription: "Elija cómo desea recibir las notificaciones",
    notificationsEnabled: "Activadas",
    notificationsDisabled: "Desactivadas",
    notificationsDisabledWarningPatient:
        "Le recomendamos activar las notificaciones por correo electrónico o SMS para recibir recordatorios importantes sobre sus registros del diario y los mensajes.",
    notificationsDisabledWarningClinician:
        "Le recomendamos activar las notificaciones por correo electrónico o SMS para recibir los resúmenes semanales de la evolución de sus pacientes.",
    notificationPreferencesSaved: "Preferencias de notificación guardadas",
    notificationPreferencesSaveFailed: "No se han podido guardar las preferencias",
    appearance: "Apariencia",
    darkMode: "Modo oscuro",
    darkModeDescription: "Use un fondo oscuro en la aplicación.",
    switchToDarkMode: "Cambiar al modo oscuro",
    switchToLightMode: "Cambiar al modo claro",
    language: "Idioma",
    languageDescription: "Elija el idioma de los menús, los botones y los recordatorios.",
    chooseLanguage: "Elegir el idioma",
    otherActions: "Otras acciones",
    billingAndSubscription: "Facturación y suscripción",
    hospitalDetails: "Datos hospitalarios",
    clinicianNumberLabel: "Número de clínico",
    clinicianNumberDescription: "Se trata de su número GMC o HCPC",
    noClinicianNumber: "Sin número de clínico",
    myOrganisations: "Mis organizaciones",
    myTeam: "Equipo",
    teamPageDescription:
        "Todas las personas de sus organizaciones. Invite a sus colegas y elija una persona de contacto predeterminada.",
    secretaryDefaultHelpTitle: "Persona de contacto predeterminada",
    secretaryDefaultHelp:
        "Su persona de contacto predeterminada para una organización se rellena como contacto cuando invita a un paciente. El primer secretario que añade pasa a ser la persona predeterminada. Puede cambiarla en la tabla.",
    secretaryDefaultColumnHelp: "Se usa como persona de contacto cuando invita a pacientes en esta organización.",
    filterRole: "Rol",
    filterOrganisation: "Organización",
    filterAddedBy: "Añadido por",
    filterAllRoles: "Todos los roles",
    filterAllOrganisations: "Todas las organizaciones",
    filterAllAddedBy: "Todos",
    filterInvitedByMe: "Invitados por mí",
    filterNotInvitedByMe: "No invitados por mí",
    filterFavouritesOnly: "Solo favoritos",
    filters: actionCopyEs.filters,
    filterTeamAria: "Filtrar el equipo",
    teamFilterTitle: "Filtros",
    teamFilterDescription: "Filtre esta lista por rol, organización y favoritos.",
    selectRoles: "Seleccionar roles",
    selectOrganisations: "Seleccionar organizaciones",
    columnsButton: actionCopyEs.columns,
    columnName: listCopyEs.name,
    columnRole: listCopyEs.role,
    columnOrganisation: listCopyEs.organisation,
    columnAddedBy: "Añadido por",
    columnDefaultSecretary: "Persona de contacto predeterminada",
    columnFavourite: "Favorito",
    invitedByYou: "Le invitó usted",
    addUser: "Añadir un usuario",
    membersShown: (count) => `${count} ${count === 1 ? "miembro" : "miembros"}`,
    defaultForOrganisation: (organisationName) => `Predeterminado para ${organisationName}`,
    setAsDefaultForOrganisation: (organisationName) => `Establecer como predeterminado para ${organisationName}`,
    viewAll: "Ver todo",
    teamLabel: "Equipo",
    staffCount: (count) => `${count} miembros del personal`,
    memberCount: (count) => `${count} ${count === 1 ? "miembro" : "miembros"}`,
    favouritesCount: (count) => `${count} ${count === 1 ? "favorito" : "favoritos"}`,
    moreTeamMembers: (count) => `+${count} miembros más del equipo`,
    noTeamMembersYet: "Ningún miembro del equipo por el momento",
    searchTeamPlaceholder: "Buscar...",
    searchTeamAria: "Buscar miembros del equipo",
    closeSearch: "Cerrar la búsqueda",
    openSearch: "Abrir la búsqueda",
    allStaff: "Todo el personal",
    invitedTab: "Invitados",
    favouritesTab: "Favoritos",
    noTeamMembersFound: "No se ha encontrado ningún miembro del equipo.",
    noFavouritesYet: "Ningún favorito por el momento.",
    noInvitesYet: "Aún no ha invitado a ningún usuario.",
    inviteColleaguesToBuildTeam: "Invite a sus colegas para empezar a formar su equipo",
    manageTeam: "Gestionar el equipo",
    secretaryOrganisationsLabel: "Organizaciones del secretario",
    secretaryDefaultBadge: "Predeterminado",
    setAsDefaultSecretary: "Establecer como predeterminado",
    clearDefaultSecretary: "Quitar como predeterminado",
    addAsMySecretary: "Añadir como mi secretario",
    removeAsMySecretary: "Quitar",
    addSecretaryForOrganisation: "Añadir un secretario",
    inviteNewSecretary: "Invitar a un nuevo secretario",
    chooseExistingSecretary: "Elegir en la organización",
    chooseExistingSecretaryTitle: "Elegir un secretario",
    noOtherSecretariesInOrganisation: "No se ha encontrado ningún otro secretario en esta organización.",
    inviteUser: "Invitar a un usuario",
    diaryUsageUsedLabel: "Uso",
    diaryUsageUnlimited: "Diarios ilimitados",
    diaryUsageAtCapHint:
        "Ha alcanzado su límite de diarios para este periodo. Cambie a un plan superior para invitar a más pacientes.",
    changePassword: "Modificar la contraseña",
    logout: "Cerrar sesión",
    help: "Ayuda",
    menu: "Menú",
    close: actionCopyEs.close,
    contactSupportPrompt: "¿Tiene alguna duda o necesita ayuda?",
    contactSupport: "Contactar con asistencia",
    incompleteTitle: "Perfil incompleto",
    incompleteMessage:
        "Para usar Patient Watch, complete primero su perfil indicando todos los campos que aparecen como pendientes a continuación.",
    profileCompletionLabel: (progress) => `Perfil completado al ${progress} %`,
    addNextMissingField: "Completar su perfil",
    addMissingName: "Añadir el nombre",
    addMissingDateOfBirth: "Añadir la fecha de nacimiento",
    addMissingEmail: "Añadir la dirección de correo electrónico",
    addMissingPhone: "Añadir el número de teléfono",
    addMissingOrganisation: "Añadir una organización",
    addMissingNotifications: "Añadir las preferencias de notificación",
    navProfileDescription: "Actualice la información necesaria para el correcto funcionamiento de Patient Watch.",
    navDiaryLabel: "Diario",
    navDiaryDescription: "Cree diarios que permitan a los pacientes seguir sus propios síntomas.",
    goToDiary: "Ir al diario",
    addDoneSeeProgress: "Añada lo que se ha hecho y siga su evolución",
    goToDiaries: "Ir a los diarios",
    seeResults: "Ver los resultados",
    seeDiaries: "Ver los diarios",
    onboarding: "Configuración inicial",
    onboardingNameTitle: "¿Cuál es su nombre?",
    onboardingNameDescription: "Así es como su clínico le identificará en Patient Watch.",
    onboardingDateOfBirthTitle: "¿Cuál es su fecha de nacimiento?",
    onboardingDateOfBirthDescription: "La usamos para vincular su historia clínica de forma segura.",
    onboardingEmailTitle: "¿Cuál es su dirección de correo electrónico?",
    onboardingEmailDescription:
        "La usaremos solo para su cuenta de Patient Watch y para los mensajes relacionados con su atención.",
    onboardingPhoneTitle: "¿Cuál es su número de teléfono?",
    onboardingPhoneDescription:
        "Los recordatorios por SMS le ayudan a completar los formularios en el momento adecuado.",
    onboardingNotificationsTitle: "¿Cómo desea recibir los recordatorios?",
    beginOnboarding: "Empezar la configuración",
    onboardingSignedOutDescription: "Haga clic en Continuar para añadir su información.",
    continue: actionCopyEs.continue,
    next: actionCopyEs.next,
    save: actionCopyEs.save,
    cancel: actionCopyEs.cancel,
    skip: actionCopyEs.skip,
    skipConfirmTitle: "¿Desea omitir este paso?",
    skipEmailDescription:
        "La dirección de correo electrónico sirve para enviar notificaciones importantes. Omitir este paso puede impedirle recibir actualizaciones a tiempo.",
    skipSmsDescription:
        "El número de teléfono sirve para enviar SMS de notificación importantes. Omitir este paso puede impedirle recibir actualizaciones a tiempo.",
    saving: actionCopyEs.saving,
    creating: "Creando...",
    organisation: listCopyEs.organisation,
    organisationMissing: "Falta la organización",
    addOrganisation: "Añadir una organización",
    joinOrganisation: "Unirse a una organización",
    organisationMissingDescription: "Únase a una organización para crear diarios.",
    addOrganisationToContinue: "Añada una organización para continuar",
    informationMissing: "Falta información",
    role: listCopyEs.role,
    openMenu: "Abrir el menú",
    showUsers: "Mostrar los usuarios",
    showQrCode: "Mostrar el código QR",
    organisationCode: "Código de la organización",
    organisationCodeDescriptionPrefix:
        "Para unirse a una organización, use el código que le han comunicado. Si no tiene uno,",
    requestCode: "solicite un código",
    cantFindOrganisation: "¿No encuentra su organización?",
    addOrganisationYourself: "Añádala usted",
    newOrganisationName: "Nombre de la organización",
    searchExistingOrganisation: "Buscar una organización existente en su lugar",
    addNewOrganisation: "Añadir organización",
    addNewOrganisationDescription: "La creamos y le añadimos como clínico. Después podrá invitar a sus colegas.",
    delete: actionCopyEs.delete,
    deleting: actionCopyEs.deleting,
    rolePatient: "Paciente",
    roleClinician: "Clínico",
    roleSecretary: "Secretario",
    roleAdmin: "Administrador",
    roleManager: "Responsable",
    roleValidator: "Validador",
    organisationDescription: "Se trata del nombre de su clínica, su consulta o su hospital.",
    profileOrganisationDescription:
        "Añadir una organización permitirá compartir datos entre usted y esta organización.",
    yourOrganisation: "Su organización",
    professional: "Profesional",
    medicalSpecialty: "Especialidad médica",
    selectSpecialty: "Seleccionar una especialidad",
    specialtyDescription: "Crearemos modelos específicos para su especialidad",
    professionalRegistrationNumber: "Número de colegiación profesional (opcional)",
    professionalRegistrationPlaceholder: "GMC, HCPC u otro número de colegiación",
    professionalRegistrationDescription: "Su número GMC, HCPC o de colegiación profesional",
    welcomeTitle: "Le damos la bienvenida a Patient Watch.",
    welcomePatientDescription:
        "Ayude a mejorar los tratamientos y la investigación siguiendo su proceso de recuperación.",
    welcomeClinicianDescription:
        "Ofrezca a sus pacientes una atención personalizada, ahorre consultas y recopile información valiosa sobre sus tratamientos.",
    welcomeSecretaryDescription:
        "Gestione las historias de los pacientes y coordine la atención de forma eficaz dentro de su equipo.",
    welcomeManagerDescription: "Supervise cómo se recopilan los datos en su organización.",
    settingUpAccount: "Configurando su cuenta...",
    gettingAccountReady: "Estamos preparándolo todo para usted",
    continueToProfileSetup: "Continuar hacia la configuración del perfil",
    processingNewUser: "Procesando al nuevo usuario",
    onboardingComplete: "Configuración inicial completada",
    authenticationError: "Error de autenticación",
    setupMoment: "Un momento, estamos configurándolo todo...",
    settingUpDiary: "Configurando su diario...",
    almostThere: "Casi terminado.",
    patientSetupCompleteDescription:
        "Gracias por haber completado la configuración. Añada sus registros del diario a medida que avance, y después podrá ver sus puntuaciones en el gráfico de evolución.",
    setupCompleteDescription: "Ahora puede usar Patient Watch para compartir su evolución.",
    supportMessage: "Envíe un mensaje a support@patient-watch.com",
    retry: actionCopyEs.retry,
    edit: actionCopyEs.edit,
    current: "Actual",
    change: "Modificar",
    deleteAccount: "Eliminar la cuenta",
    deleteAccountConfirmTitle: "¿Está completamente seguro?",
    deleteAccountConfirmDescription:
        'Esta acción es irreversible. Para confirmar que desea eliminar su cuenta, indique "delete my account" a continuación.',
    deleteAccountPageDescription: "Elimine de forma definitiva su cuenta y todos los datos asociados",
    deleteAccountReason: "Motivo de la eliminación de la cuenta",
    deleteAccountSubmit: "Eliminar la cuenta",
    submitting: actionCopyEs.submitting,
    deleteAccountConfirmationLabel: "Confirmación",
    deleteAccountPlaceholder: 'Indique "delete my account"',
    deletingAccount: "Eliminando...",
    warningNotificationsDisabled: "Atención: notificaciones desactivadas",
    editPreferences: "Modificar las preferencias",
    remindersDescription: "Los recordatorios son esenciales para que Patient Watch mejore su salud.",
    receiveEmailReminders: "Recibir recordatorios por correo electrónico.",
    receiveSmsReminders: "Recibir recordatorios por SMS.",
    pushNotificationSettingsError:
        "Para activar las notificaciones push, debe activar las notificaciones en los ajustes de su aplicación.",
    actionRequired: (count) => `Acción requerida (${count})`,
    actionRequiredForms: (count) => `Acción requerida (${count} formulario${count === 1 ? "" : "s"})`,
    diaryCardDescription:
        "Los diarios son sus seguimientos de salud personales y ayudan a mejorar los tratamientos y la investigación.",
    formDue: (count) => `Tiene ${count} formulario${count === 1 ? "" : "s"} por completar.`,
    diariesNeedAttention: (count) =>
        `Tiene ${count} ${count === 1 ? "diario" : "diarios"} cuyos formularios requieren su atención.`,
    welcomeModalTitle: (name: string) => `Le damos la bienvenida, ${name}.`,
    welcomeDescription:
        "Su cuenta está completamente configurada y los modelos de su especialidad están listos para usar.",
    welcomeTestPatientTitle: "Pruebe con un paciente de prueba",
    welcomeTestPatientDescription:
        "Para ver cómo vivirán Patient Watch sus pacientes, invite a un usuario de prueba con otra dirección de correo electrónico.",
    welcomeAddFirstPatient: "Añadir mi primer paciente",
    welcomeDoctorFallback: "Doctor",
    closeBanner: "Cerrar el banner",
    home: "Página de inicio",
    currentPlan: "Plan actual",
    currentPlanDescription: "Su suscripción y su cupo de diarios",
    noActiveSubscription: "No tiene una suscripción activa",
    billingStatus: "Estado",
    nextBillingDate: "Próxima fecha de facturación",
    accessUntil: "Acceso hasta el",
    planDetails: "Detalles del plan",
    trialPlanDetails: "5 diarios nuevos por periodo de facturación",
    enterprisePlanDetails: "Diarios ilimitados",
    choosePlanToStart: "Elija un plan para empezar con Patient Watch",
    upgradeYourPlan: "Cambiar a un plan superior",
    changeYourPlan: "Cambiar de plan",
    availablePlans: "Planes disponibles",
    upgradePlanDescription: "Pase del plan gratuito a Starter o Pro para un cupo de diarios más alto",
    changePlanDescription: "Compare los planes y modifique su suscripción",
    choosePlanDescription: "Elija el plan que mejor se adapte a sus necesidades",
    preferStartFree: "¿Prefiere empezar de forma gratuita?",
    createFreeAccount: "Crear una cuenta gratuita",
    needMore: "¿Necesita más? Descubra nuestro",
    enterprisePlan: "plan Enterprise",
    cancelSubscription: "Cancelar la suscripción",
    managePaymentMethod: "Gestionar el método de pago",
    undoCancellationHint:
        "¿Desea mantener su plan? Use « Gestionar el método de pago » para volver a abrir Stripe y anular la cancelación.",
    paymentRequired: "Pago requerido",
    paymentOverdue: "Su pago está atrasado. Actualice el método de pago para seguir usando Patient Watch.",
    subscriptionCanceling: "Cancelación de la suscripción en curso",
    subscriptionCancelingOn: (date) => `Su suscripción se cancelará el ${date}. Mantendrá el acceso hasta esa fecha.`,
    subscriptionCancelingPeriod:
        "Su suscripción se cancelará al final del periodo de facturación. Mantendrá el acceso hasta esa fecha.",
    subscriptionCancelled: "Suscripción cancelada",
    subscriptionCancelledDescription:
        "Su suscripción de pago ha terminado. Elija un plan a continuación para reanudar la facturación.",
    unableToCancel: "No se ha podido cancelar",
    unableToChangePlan: "No se ha podido cambiar de plan",
    unableToOpenBillingPortal: "No se ha podido abrir el portal de facturación",
    unableToStartCheckout: "No se ha podido iniciar el pago",
    failedToLoadBilling: "No se ha podido cargar la información de facturación. Vuelva a intentarlo más tarde.",
    billingStatusCanceling: "CANCELACIÓN EN CURSO",
    billingStatusUnknown: "DESCONOCIDO",
    pleaseTryAgain: "Vuelva a intentarlo.",
    planStarter: "Starter",
    planPro: "Pro",
    perMonth: "/mes",
    currentPlanBadge: "Actual",
    popularBadge: "Popular",
    starterDiaries: "20 diarios nuevos/mes",
    proDiaries: "50 diarios nuevos/mes",
    emailSmsReminders: "Recordatorios por correo electrónico y SMS",
    emailSupport: "Asistencia por correo electrónico",
    prioritySupport: "Asistencia prioritaria",
    currentPlanButton: "Plan actual",
    subscribeToStarter: "Suscribirse a Starter",
    subscribeToPro: "Suscribirse a Pro",
    downgradeToStarter: "Cambiar a Starter",
    upgradeToPro: "Cambiar a Pro",
    includedInEnterprise: "Incluido en Enterprise",
};
